<template>
    <div class="suggest" :class="{'d-none': !visible || !id}">
        <div class="suggest__overlay"></div>

        <div class="suggest__modal">
            <div class="suggest__offers" v-if="offers && offers.length > 0 && step === 1">
                <p class="fs-2 fw-bold text-center">Votre produit a bien été ajouté au panier.</p>
                <p class="text-center mb-4" style="font-size: 18px; list-style-position: inside;">
                    Nous vous conseillons avec cette prestation :
                </p>
                <div class="suggest__content mb-4">
                    <div class="suggest__content-item" v-for="offer in offers"
                         @click="select(offer.prestation_discount.id, 'offers')"
                         :key="'offer-'+offer.id"
                         :class="{'suggest__content-item--active': selected.offers.findIndex(el => el.id === offer.prestation_discount.id) !== -1}">
                        <div class="suggest__content-item-header">
                            <button class="btn bg-white">Choisir</button>
                            <img :alt="offer.prestation_discount?.name"
                                 :src="offer.prestation_discount?.image || 'https://www.spabeautedange.fr/wp-content/uploads/2019/07/soin.jpg'">
                        </div>
                        <div class="suggest__content-item-content">
                            <span class="suggest__content-item-content-time" v-if="offer.prestation_discount?.duration">
                                <svg xmlns="http://www.w3.org/2000/svg" class="d-inline-block mr-1" width="12.601"
                                     height="12.601" viewBox="0 0 12.601 12.601"><g id="time-svgrepo-com_34_"
                                                                                    data-name="time-svgrepo-com (34)"
                                                                                    transform="translate(-0.001 0)"><path
                                    id="Tracé_518" data-name="Tracé 518"
                                    d="M6.3,0a6.3,6.3,0,1,0,6.3,6.3A6.307,6.307,0,0,0,6.3,0Zm0,11.689A5.389,5.389,0,1,1,11.69,6.3,5.4,5.4,0,0,1,6.3,11.689Z"
                                    transform="translate(0)" fill="#fff" stroke="#fff" stroke-width="0.001"/><path
                                    id="Tracé_519" data-name="Tracé 519"
                                    d="M40.778,23h-.007l-1.36.02v-3.56a.455.455,0,1,0-.911,0v4.026s0,0,0,0a.445.445,0,0,0,.006.054c0,.011,0,.022,0,.033a.431.431,0,0,0,.017.056c0,.01.005.02.009.029a.471.471,0,0,0,.029.053c0,.008.008.016.013.024a.48.48,0,0,0,.039.047c.006.006.01.014.017.02a.478.478,0,0,0,.048.039l.019.016a.441.441,0,0,0,.057.031l.02.011a.467.467,0,0,0,.072.022l.014,0a.463.463,0,0,0,.091.009h.007l1.823-.027A.455.455,0,0,0,40.778,23Z"
                                    transform="translate(-32.655 -16.116)" fill="#fff" stroke="#fff"
                                    stroke-width="0.001"/></g></svg>
                                {{ offer.prestation_discount?.duration }} MIN
                            </span>
                            <h2 v-if="offer.prestation_discount?.name">{{ offer.prestation_discount?.name }}</h2>
                            <h3 v-if="offer.prestation_discount?.subtitle">{{
                                    offer.prestation_discount?.subtitle
                                }}</h3>
                            <div class="suggest__content-item-content-info">
                                <p class="suggest__content-item-content-info-price">
                                    <span>Prix :</span>
                                    <b>{{
                                            offer.prestation_discount?.price - (offer.prestation_discount?.discount || 0)
                                        }}€</b>

                                    <span v-if="offer.discount_amount !== 0 && offer.discount_type === 'fixed'">
                                        <span>Réduction :</span> <b>-{{ offer.discount_amount }}€</b>
                                    </span>
                                    <span v-if="offer.discount_amount !== 0 && offer.discount_type === 'fixed'">
                                        <span>Prix final :</span>
                                        <b>{{
                                                offer.prestation_discount?.price - (offer.prestation_discount?.discount || 0) - offer.discount_amount
                                            }}€</b>
                                    </span>

                                    <span v-if="offer.discount_amount !== 0 && offer.discount_type === 'percentage'">
                                        <span>Réduction :</span> <b>{{ offer.discount_amount }}%</b>
                                    </span>
                                    <span v-if="offer.discount_amount !== 0 && offer.discount_type === 'percentage'">
                                        <span style="color: #707070">Prix final :</span>
                                        <b>{{
                                                (offer.prestation_discount.price - (offer.prestation_discount?.discount || 0)) * (1 - (offer.discount_amount / 100))
                                            }}€</b>
                                    </span>
                                </p>
                                <div class="suggest__content-item-content-info-detail">
                                    <a class="suggest__content-item-content-info-detail-more" href="javascript:">En
                                        savoir plus</a>
                                    <div v-html="offer.prestation_discount.description"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="suggest__footer">
                    <button class="btn" @click="prev()" v-if="ifPrevStep">Précédent</button>
                    <button class="btn" @click="next()" v-if="ifNextStep">Suivant</button>
                    <button class="btn" @click="validate()" v-else>
                        Continuer
                        <span class="suggest__loader" v-show="loading"></span>
                    </button>
                </p>
            </div>
            <div class="suggest--options" v-if="options && options.length > 0 && step === 2">
                <p class="fs-2 fw-bold text-center">Poussons plus loin votre expérience</p>
                <p class="text-center mb-4" style="font-size: 18px; list-style-position: inside;">
                    Agrémentez votre prestation avec ses options proposées.
                </p>
                <div class="suggest__content mb-4">
                    <div class="suggest__content-item" v-for="option in options"
                         @click="select(option.item.id, 'options', option.type, option.item?.quantity)"
                         :key="'option-'+option.id"
                         :class="{'suggest__content-item--active': selected.options.findIndex(el => el.id === option.item.id) !== -1}">
                        <div class="suggest__content-item-header">
                            <button class="btn bg-white"
                                    v-if="option.type === 'prestation' || option.item?.quantity > 0">Choisir
                            </button>
                            <button class="btn bg-white" disabled v-else>Indisponible</button>
                            <img :alt="option.item?.name"
                                 :src="getImage(option.item)">
                        </div>
                        <div class="suggest__content-item-content">
                            <h2 v-if="option.item?.name">{{ option.item?.name }}</h2>

                            <div class="suggest__content-item-content-info">
                                <p class="suggest__content-item-content-info-price">
                                    <b>{{
                                            option.item?.price - (option.item?.discount_price || 0)
                                        }}€</b>
                                </p>

                                <div class="suggest__content-item-content-info-detail">
                                    <a class="suggest__content-item-content-info-detail-more" href="javascript:">
                                        En savoir plus
                                    </a>
                                    <div v-html="option.item?.description || 'Pas de description pour ce soin.' "></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="suggest__footer">
                    <button class="btn" @click="prev()" v-if="ifPrevStep">Précédent</button>
                    <button class="btn" @click="next()" v-if="ifNextStep">Suivant</button>
                    <button class="btn" @click="validate()" v-else>
                        Continuer
                        <span class="suggest__loader" v-show="loading"></span>
                    </button>
                </p>
            </div>
            <div class="suggest--products" v-if="products && products.length > 0 && step === 3">
                <p class="fs-2 fw-bold text-center">Poussons plus loin votre expérience</p>
                <p class="text-center mb-4" style="font-size: 18px; list-style-position: inside;">
                    Souhaitez vous mettre ses produits de côté pour votre arrivée ?
                </p>
                <div class="suggest__content mb-4">
                    <div class="suggest__content-item" v-for="item in products"
                         @click="select(item.product.id, 'products', null, item.product?.quantity)"
                         :key="'product-'+item.id"
                         :class="{'suggest__content-item--active': selected.products.findIndex(el => el.id === item.product.id) !== -1}">
                        <div class="suggest__content-item-header">
                            <button class="btn bg-white" v-if="item.product?.quantity > 0">Choisir</button>
                            <button class="btn bg-white" disabled v-else>Indisponible</button>
                            <img :alt="item.product?.name"
                                 :src="getImage(item.product)">
                        </div>

                        <div class="suggest__content-item-content">
                            <h2 v-if="item.product?.name">{{ item.product?.name }}</h2>

                            <div class="suggest__content-item-content-info">
                                <p class="suggest__content-item-content-info-price">
                                    <b>{{
                                            item.product?.price - (item.product?.discount_price || 0)
                                        }}€</b>
                                </p>

                                <div class="suggest__content-item-content-info-detail">
                                    <a class="suggest__content-item-content-info-detail-more" href="javascript:">
                                        En savoir plus
                                    </a>
                                    <div
                                        v-html="item.product?.description || 'Pas de description pour cet article.' "></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="suggest__footer">
                    <button class="btn" @click="prev()" v-if="ifPrevStep">Précédent</button>
                    <button class="btn" @click="next()" v-if="ifNextStep">Suivant</button>
                    <button class="btn" @click="validate()" v-else>
                        Continuer
                        <span class="suggest__loader" v-show="loading"></span>
                    </button>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";

export default {
    data: () => ({
        loading: false,
        refresh: null,
        id: null,
        step: 1,
        offers: [],
        options: [],
        products: [],
        selected: {
            offers: [],
            options: [],
            products: []
        },
        visible: false,
    }),
    props: {
        goToCart: Boolean,
    },
    computed: {
        ifNextStep()
        {
            let step = this.step + 1;
            if (step === 1 && this.offers.length === 0) step++;
            if (step === 2 && this.options.length === 0) step++;

            if (step === 1 && this.offers.length > 0) return true;
            if (step === 2 && this.options.length > 0) return true;
            if (step === 3 && this.products.length > 0) return true;
            return false;
        },
        ifPrevStep()
        {
            let step = this.step - 1;
            if (step === 3 && this.products.length === 0) step--;
            if (step === 2 && this.options.length === 0) step--;

            if (step === 1 && this.offers.length > 0) return true;
            if (step === 2 && this.options.length > 0) return true;
            if (step === 3 && this.products.length > 0) return true;
            return false;
        }
    },
    mounted()
    {
        this.click = this.click.bind(this);
        document.addEventListener('click', this.click);
    },

    beforeDestroy()
    {
        document.removeEventListener('click', this.click);
    },

    methods: {
        click(evt)
        {
            if (evt && evt.target && evt.target.closest('[data-add-to-cart]')) {
                const target = evt.target.closest('[data-add-to-cart]');
                if (!target) return;

                this.id = parseInt(target.getAttribute('data-add-to-cart')) || null;
                this.getOffers();
            } else if (evt && evt.target && evt.target.closest('.suggest__content-item-content-info-detail-more')) {
                evt.preventDefault();
                evt.stopPropagation();
                evt.target.closest('.suggest__content-item-content-info-detail').classList.toggle('suggest__content-item-content-info-detail--active');
            } else {
                document.querySelectorAll('.suggest__content-item-content-info-detail--active').forEach(el => el.classList.remove('suggest__content-item-content-info-detail--active'));
            }
        },

        getOffers()
        {
            if (!this.id) return;

            axios.post(`/api/options`, {'id': this.id}).then(response => {
                if (response.status === 200 && response.data) {
                    this.offers = response.data.offers || [];
                    this.options = response.data.options || [];
                    this.products = response.data.products || [];
                    this.selected = {
                        offers: [],
                        options: [],
                        products: []
                    };

                    if (this.offers.length > 0) {
                        this.step = 1;
                        this.visible = true;
                    } else if (this.options.length > 0) {
                        this.step = 2;
                        this.visible = true;
                    } else if (this.products.length > 0) {
                        this.step = 3;
                        this.visible = true;
                    }
                }
            });
        },

        getImage(item)
        {
            if (item?.image) {
                return item.image;
            }

            if (item?.img1) {
                return item.img1;
            }

            if (item?.img2) {
                return item.img2;
            }

            if (item?.img3) {
                return item.img3;
            }

            return '/media/75542-leaf-growing.gif';
        },

        select(id, type, params = null, quantity = null)
        {
            const index = this.selected[type].findIndex(el => el.type === type && el.id === id);
            if (index !== -1) {
                this.selected[type].splice(index, 1);
                return;
            }

            if (quantity !== null && quantity <= 0) return;

            this.selected[type].push({type: type, id: id, params: params});
        },

        next()
        {
            if (this.step < 3) {
                this.step++;
            }

            if (this.step === 1 && this.offers.length === 0) this.step++;
            if (this.step === 2 && this.options.length === 0) this.step++;
            if (this.step === 3 && this.products.length === 0) this.validate();
            console.log(this.step);
        },

        prev()
        {
            if (this.step > 1) {
                this.step--;
            }

            if (this.step === 3 && this.products.length === 0) this.step--;
            if (this.step === 2 && this.options.length === 0) this.step--;
        },

        async validate()
        {
            if (this.loading) return;

            this.loading = true;
            for (let key in this.selected) {
                let url = null;
                let data = null;

                switch (key) {
                    case 'offers':
                        if (this.selected[key].length > 0) {
                            url = `/soin/${this.id}/addMultipleToBasket`;
                            data = new FormData();
                            data.append('prestation', this.id);
                            this.selected[key].forEach(item => data.append('additionnal_offers[]', item.id));
                        }
                        break;
                    case 'options':
                        if (this.selected[key].length > 0) {
                            url = `/soin/reservation/option`;
                            data = new FormData();
                            this.selected[key].forEach(item => {
                                let type = item.params === 'prestation' ? 'prestations' : 'products';
                                data.append(`options[${this.id}][${type}][]`, item.id)
                            });
                        }
                        break;
                    case 'products':
                        if (this.selected[key].length > 0) {
                            url = `/soin/reservation/recommandation`;
                            data = new FormData();
                            this.selected[key].forEach(item => data.append(`selected_products[${this.id}][]`, item.id));
                        }
                        break;
                }

                if (url !== null) {
                    console.log(url, key)
                    try {
                        await axios.post(url, data);
                    } catch (error) {
                        console.log(error);
                    }
                }
            }

            if (this.goToCart) {
                window.location.href = '/panier';
            } else {
                if (this.refresh) clearTimeout(this.refresh);
                this.refresh = setTimeout(() => $("#header").load("/ #header"), 500);
                this.loading = false;
                this.visible = false;
            }
        }
    }
}
</script>
